declare global {
    interface Window {
      env: any
    }
  }
  
  // change with your own variables
  type EnvType = {
    GA_MEASUREMENT_ID: string,
  }

  export const frontEnv: EnvType = { ...window.env }